<script setup>
import { useRoute } from 'vue-router';
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { getProperties, navigateTo } from '@versions/x/jarvx-handler';
import { getJarvxHostname } from '@versions/x/models/headers-handler';
import simplebar from 'simplebar-vue';

const store = useStore();
const route = useRoute();
const targetOrigin = getJarvxHostname();
const jarvxSidebarDisplayedState = computed(() => store.state.layout.jarvxSidebarDisplayedState);

const receiveMessage = (event) => {
  // Check the origin of the message for security. Allow only JarvX hosted
  if (event.origin !== targetOrigin) {
    return;
  }

  // handle the navigation message
  let message = {};
  try {
    message = JSON.parse(event.data);
  } catch (e) {
    console.error('Error parsing postMessage data:', event.data);
  }

  switch (message.type) {
    case 'user':
      event.source.postMessage(
        {
          type: message.type,
          data: getProperties(route, message.content || []),
        },
        event.origin
      );
      break;
    case 'navigation':
      navigateTo(route, message);
      break;
  }
};

onMounted(() => {
  window.addEventListener('message', receiveMessage);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', receiveMessage, false);
});
</script>

<template>
  <simplebar class="h-100" v-show="jarvxSidebarDisplayedState">
    <div class="javx">
      <iframe
        ref="jarvxIframe"
        :src="`${targetOrigin}/jarvx_platform/`"
        allow="clipboard-read; clipboard-write"
      ></iframe>
    </div>
  </simplebar>
</template>

<style scoped>
.javx {
  top: 70px;
  right: 0px;
  width: 400px;
  z-index: 1001;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  -webkit-box-shadow: -0.32rem -0.32rem 0.94rem rgba(18, 38, 63, 0.07);
  box-shadow: -0.32rem -0.32rem 0.94rem rgba(18, 38, 63, 0.07);
}

.javx iframe {
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
